export const LOOP_THROUGH_LIST_MAX_ITEMS = 100;
export const LOOP_THROUGH_LIST_MAX_COMPONENTS = 3;
